module.exports = __webpack_public_path__ + "fef892894f2898e2ed72f7cf69a97ab6.pdf";